import { ReportBlockTypeEnum } from './report-block-type.enum';

export const chartsOverTimeMap: Array<ReportBlockTypeEnum> = [
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.AUDIENCE_REACH_OVER_TIME,
    ReportBlockTypeEnum.AUDIENCE_REACH_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.PROMINENCE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
    ReportBlockTypeEnum.REFERRAL_TREND,
    ReportBlockTypeEnum.SENTIMENT_TREND,
    ReportBlockTypeEnum.RECENT_TOPICS,
];
